import axios from "../../axiosConfig";
import { TOAST_SHOW } from "../Actions/ToastAction";
import {
  GET_ALL_USERS_FAILED,
  GET_ALL_USERS_SUCCESS,
  GET_INVITED_USERS_FAILED,
  GET_INVITED_USERS_SUCCESS,
  GET_INVITE_FAILED,
  GET_INVITE_SUCCESS,
  GET_MY_PATIENT_DETAILS_FAILED,
  GET_MY_PATIENT_DETAILS_SUCCESS,
  GET_PRACTIONERS_FAILED,
  GET_PRACTIONERS_SUCCESS,
  GET_USERS_FAILED,
  GET_USERS_SUCCESS,
  PRACTIONERS_DETAILS_FAILED,
  PRACTIONERS_DETAILS_SUCCESS,
  USERS_DETAILS_FAILED,
  USERS_DETAILS_SUCCESS,
  USERS_REMOVE_SUCCESS,
  USERS_REMOVE_FAILED,
  USER_STATUS_UPDATE_FAILED,
  USER_STATUS_UPDATE_SUCCESS,
  GET_USERS_EMAIL_SUCCESS,
  GET_USERS_EMAIL_FAILED,
  GET_USER_PROGRAM_GRAPH_SUCCESS,
  GET_USER_PROGRAM_GRAPH_FAILED,
  GET_USER_WATCH_GRAPH_FAILED,
  GET_USER_WATCH_GRAPH_SUCCESS,
  PATIENT_REMOVE_FAILED,
  PATIENT_REMOVE_SUCCESS,
  GET_PRACTITIONERS_EMAIL_FAILED,
  GET_PRACTITIONERS_EMAIL_SUCCESS,
  MAINTENANCE_MODE_SUCCESS,
  MAINTENANCE_MODE_FAILED,
  GET_MAINTENANCE_MODE_SUCCESS,
  GET_MAINTENANCE_MODE_FAILED,
} from "../Actions/userAction";
import { put, call } from "redux-saga/effects";
import decryptResponse from "../../Components/Decrypt";

export function* userSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-my-patients`,
      action?.payload
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_USERS_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_USERS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* allUserSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-all-patients`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_ALL_USERS_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_ALL_USERS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* practionerSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-all-doctors`,
      action?.payload
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_PRACTIONERS_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_PRACTIONERS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* invitedUserSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-my-invited-patients`,
      action?.payload
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);    
    yield put({ type: GET_INVITED_USERS_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_INVITED_USERS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* inviteSaga(action) {
  try {
    const response = yield call(axios.post, `/invite-patient`, action.payload);
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_INVITE_SUCCESS, payload: decryptData });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: GET_INVITE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* userDetailSaga(action) {
  try {
    const response = yield call(
      axios.get,
      `/get-user-profile-by-Id/${parseInt(action.payload)}`
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: USERS_DETAILS_SUCCESS, payload: decryptData });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: USERS_DETAILS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* myPatientDetailSaga(action) {
  try {
    const response = yield call(
      axios.get,
      `/get-user-profile-by-Id/${parseInt(action.payload)}`
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_MY_PATIENT_DETAILS_SUCCESS, payload: decryptData });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: GET_MY_PATIENT_DETAILS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* practionerDetailSaga(action) {
  try {
    const response = yield call(
      axios.get,
      `/get-user-profile-by-Id/${action?.payload}`
    );
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: PRACTIONERS_DETAILS_SUCCESS, payload: decryptData });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: PRACTIONERS_DETAILS_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
export function* userRemoveSaga(action) {
  try {
    const response = yield call(
      axios.delete,
      `/delete-user-by-Id/${action?.payload?.Id}`,
      action.payload
    );
    const { success, data, message, errors } = response?.data;
    yield put({ type: USERS_REMOVE_SUCCESS, payload: action?.payload });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: USERS_REMOVE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.type,
        severity: "error",
      },
    });
  }
}
export function* patientRemoveSaga(action) {
  try {
    let selectedTab = action.payload.user_type;
    let response;
    selectedTab === "CLIENTS"
      ? (response = yield call(
          axios.delete,
          `/delete-doctor-patient/${action?.payload?.Id}`,
          action.payload
        ))
      : (response = yield call(
          axios.delete,
          `/delete-invited-patient/${action?.payload?.Id}`,
          action.payload
        ));

    const { message } = response?.data;
    yield put({
      type: PATIENT_REMOVE_SUCCESS,
      payload: action?.payload,
    });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: PATIENT_REMOVE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.type,
        severity: "error",
      },
    });
  }
}
export function* updateUserStatusSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/change-user-active-status`,
      action.payload
    );
    const { user_type } = action?.payload;
    const { success, data, message, errors } = response?.data;
    const newData = { data, user_type };

    yield put({
      type: USER_STATUS_UPDATE_SUCCESS,
      payload: newData,
    });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: USER_STATUS_UPDATE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.type,
        severity: "error",
      },
    });
  }
}

export function* getPractitionersEmailSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-doctor-email-list`,
      action.payload
    );

    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({
      type: GET_PRACTITIONERS_EMAIL_SUCCESS,
      payload: { decryptData, success },
    });
  } catch (e) {
    yield put({ type: GET_PRACTITIONERS_EMAIL_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.type,
        severity: "error",
      },
    });
  }
}
export function* getClientsEmailSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-user-email-list`,
      action.payload
    );

    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({
      type: GET_USERS_EMAIL_SUCCESS,
      payload: { decryptData, success },
    });
  } catch (e) {
    yield put({ type: GET_USERS_EMAIL_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.type,
        severity: "error",
      },
    });
  }
}
export function* getUserProgramGraphSaga(action) {
  try {
    const response = yield call(
      axios.get,
      `/get-user-program-graph/${action.payload}`
    );

    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({
      type: GET_USER_PROGRAM_GRAPH_SUCCESS,
      payload: decryptData,
    });
  } catch (e) {
    yield put({ type: GET_USER_PROGRAM_GRAPH_FAILED });
  }
}
export function* getUserWatchGraphSaga(action) {
  try {
    const response = yield call(
      axios.get,
      `/get-user-all-watch-data/${action.payload}`
    );

    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({
      type: GET_USER_WATCH_GRAPH_SUCCESS,
      payload: decryptData,
    });
  } catch (e) {
    yield put({ type: GET_USER_WATCH_GRAPH_FAILED });
  }
}
export function* getMaintenanceModeStatusSaga(action) {
  try {
    const response = yield call(
      axios.get,
      `/get-maintenance-status`
    );

    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({
      type: GET_MAINTENANCE_MODE_SUCCESS,
      payload: decryptData,
    });
  } catch (e) {
    yield put({ type: GET_MAINTENANCE_MODE_FAILED });
  }
}
export function* maintenanceModeStatusSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/update-maintenance-status`,action.payload
    );

    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({
      type: MAINTENANCE_MODE_SUCCESS,
      payload: decryptData,
    });
  } catch (e) {
    yield put({ type: MAINTENANCE_MODE_FAILED });
  }
}
